import { Injectable } from '@angular/core';

import { UserDTO } from '../auth/models/user-dto.model';
import { UserRoleEnum } from '../auth/user-role-enum';


@Injectable({
  providedIn: 'root',
})
export class UserService {
  private currentUser!: UserDTO;

  public setUser(user: UserDTO): void {
    this.currentUser = user;
  }

  public userIsLoggedIn(): boolean {
    if (this.currentUser?.userId > 0) {
      return true;
    }
    return false;
  }

  public userIsAdmin(): boolean {
    return (this.currentUser?.roles?.map(
      r => r.roleId
    ))?.includes(UserRoleEnum.UserAdmin);
  }

  public userHasRole(roleId: number): boolean {
    if (this.currentUser) {
      const roleIdsUserHas = this.currentUser.roles.map((r) => r.roleId);
      return roleIdsUserHas.includes(roleId);
    }
    return false;
  }
}
